import "./style.scss";
import { Link } from "react-router-dom";
import footerLogoMob from "@/src/assets/Footer/footer-logo-mob.png";
import WhatsApp from "@/src/svg/Whatsapp";
import Admissions from "@/src/svg/Admissions";
import Map from "../../Map/Map";
import FacebookWhite from "@/src/svg/FacebookWhite";
import InstagramWhite from "@/src/svg/InstagramWhite";
import YoutubeWhite from "@/src/svg/YoutubeWhite";
import TiktokWhite from "@/src/svg/TiktokWhite";
import MailFooter from "@/src/svg/MailFooter";

const FooterMob = () => {
  return (
    <section className="footer-mob section-margin-top">
      <div className="footer-mob-top">
        <div className="container">
          <div className="footer-mob-banner">
            <div className="footer-mob-banner-logo">
              <img src={footerLogoMob} alt="Footer Logo" />
            </div>
            <div className="footer-mob-banner-content">
              <div className="footer-mob-banner-title">
                <p>Хотите узнать больше? Напишите нам!</p>
              </div>
              <div className="footer-mob-banner-subtitle">
                <p>
                  <span>Мальтийская школа медицины и бизнеса</span> будет рада ответить на ваши вопросы.
                </p>
              </div>
            </div>
          </div>
          <div className="footer-mob-buttons">
            <Link to={"/apply-online"} className="footer-mob-buttton-leave">
              Ваше сообщение →
            </Link>
            <Link to={"/"} className="footer-mob-buttton whatsapp">
              <WhatsApp />
              <p>Whatsapp</p>
            </Link>
            <a href="mailto:info@msmbmalta.com" className="footer-mob-buttton mail">
              <MailFooter />
              <p>Email</p>
            </a>
          </div>
          <div className="footer-mob-useful">
            <div className="footer-mob-useful-title">
              <p>Полезные ссылки</p>
            </div>
            <div className="footer-mob-useful-links">
              <Link to={"/"} className="footer-mob-useful-link">
                <Admissions />
                <p>Процесс приема</p>
              </Link>
              <Link to={"/"} className="footer-mob-useful-link">
                <Admissions />
                <p>Болонский процесс</p>
              </Link>
              <Link to={"/"} className="footer-mob-useful-link">
                <Admissions />
                <p>Прибытие и встреча</p>
              </Link>
              <Link to={"/"} className="footer-mob-useful-link">
                <Admissions />
                <p>Зарубежные представители</p>
              </Link>
            </div>
          </div>
          <div className="footer-mob-map">
            <Map />
          </div>
        </div>
      </div>
      <div className="footer-mob-bottom">
        <div className="container">
          <div className="footer-mob-bottom-title">
            <p>Мальтийская школа медицины и бизнеса</p>
          </div>
          <div className="footer-mob-bottom-line"></div>
          <div className="footer-mob-bottom-socials">
            <Link to={"/"} className="footer-mob-bottom-social">
              <FacebookWhite />
            </Link>
            <Link to={"/"} className="footer-mob-bottom-social">
              <InstagramWhite />
            </Link>
            <Link to={"/"} className="footer-mob-bottom-social">
              <YoutubeWhite />
            </Link>
            <Link to={"/"} className="footer-mob-bottom-social">
              <TiktokWhite />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FooterMob;
